export const ORG_ANALYTICS_PDF_SECTION = {
  summary: 'summary',
  scoreTrend: 'score_trend',
  callVolumeTrend: 'call_volume_trend',
  performanceRadar: 'performance_radar',
  complianceFailureRate: 'compliance_failure_rate',
  escalationRate: 'escalation_rate',
  questionRates: 'question_rates',
  callAnalytics: 'call_analytics',
} as const;

export const ORG_ANALYTICS_PDF_SECTIONS = [
  { id: ORG_ANALYTICS_PDF_SECTION.summary, label: 'Summary' },
  { id: ORG_ANALYTICS_PDF_SECTION.scoreTrend, label: 'Score Trend' },
  { id: ORG_ANALYTICS_PDF_SECTION.callVolumeTrend, label: 'Call Volume' },
  { id: ORG_ANALYTICS_PDF_SECTION.performanceRadar, label: 'Performance Radar' },
  { id: ORG_ANALYTICS_PDF_SECTION.complianceFailureRate, label: 'Compliance Failure Rate' },
  { id: ORG_ANALYTICS_PDF_SECTION.escalationRate, label: 'Escalation Rate' },
  { id: ORG_ANALYTICS_PDF_SECTION.questionRates, label: 'Question Pass & Miss Rates' },
  { id: ORG_ANALYTICS_PDF_SECTION.callAnalytics, label: 'Call Analytics' },
] as const;

export type OrgAnalyticsPdfSectionId = (typeof ORG_ANALYTICS_PDF_SECTIONS)[number]['id'];

export const DEFAULT_ORG_ANALYTICS_PDF_SECTION_IDS: OrgAnalyticsPdfSectionId[] =
  ORG_ANALYTICS_PDF_SECTIONS.map(section => section.id);
